import { useState, useEffect } from 'react'

export function ChatImageWithLoadingState({
  src,
  alt,
  className,
}: {
  src: string
  alt: string
  className: string
}) {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    const img = new Image()
    img.onload = () => {
      setIsLoading(false)
    }
    img.onerror = () => {
      setError(true)
      setIsLoading(false)
    }
    img.src = src
  }, [src])

  if (error) {
    return (
      <div className={`${className} flex items-center justify-center bg-gray-200`}>
        <div className="p-2 text-center text-xs text-gray-500">
          <div className="mb-1 font-medium">Failed to load image</div>
          <div className="break-all text-[10px] opacity-75">{src.substring(0, 50)}...</div>
        </div>
      </div>
    )
  }

  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-100">
          <div className="flex flex-col items-center gap-2">
            <div className="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-primary" />
            <span className="text-xs text-gray-500">Loading...</span>
          </div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setError(true)
          setIsLoading(false)
        }}
      />
    </div>
  )
}
